import moment from "moment";
import LocalizedStrings from "react-localization";
import { Card, Flex, Grid, Text } from "@aws-amplify/ui-react";

const RuleCard = ({ item }) => (
  <Card height="fit-content" borderRadius="medium" variation="outlined">
    <Grid
      gap={20}
      className="m-3"
      templateColumns={{
        medium: "4fr 2fr",
      }}
    >
      <Flex>
        <div>
          <Text variation="primary" as="p" fontWeight={500}>
            {item.name}
          </Text>
          <Text variation="tertiary" as="p">
            {item.companyName} - {item.branchName} - {item.deviceName}
          </Text>
        </div>
      </Flex>
      <div>
        <Text variation="tertiary" as="p">
          {strings.activatedAt}:{" "}
          {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
        </Text>
      </div>
    </Grid>
  </Card>
);

const strings = new LocalizedStrings({
  es: {
    activatedAt: "Fecha activado",
  },
});

export default RuleCard;
